import { render, staticRenderFns } from "./NewsWindow.vue?vue&type=template&id=95080358&"
import script from "./NewsWindow.vue?vue&type=script&lang=js&"
export * from "./NewsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports